// store/index.js
export default {
    state: {
        browserTabs: localStorage.getItem('browserTabs') || null
    },

    mutations: {

        setTab(state, browserTabs) {
            state.browserTabs = browserTabs
            localStorage.setItem('browserTabs', browserTabs)
        }
    },

    actions: {
        GET_TABS({ commit }) {
            const browserTabs = localStorage.getItem('browserTabs')
            if (browserTabs) commit('setTab', browserTabs)
                console.log('setTab', browserTabs)
        },
        SET_TABS({ commit }, data) {
            commit('setTab', JSON.stringify(data))
        }
    },
    getters: {
        browserTabs: state => state.browserTabs
    }
}
